import React from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Footer from '../Shared/Footer/Footer';
import Menubar from '../Shared/MenuBar/Menubar';
import { FaFacebookF,FaLinkedinIn } from 'react-icons/fa';
import { FiGithub } from 'react-icons/fi';
import './AboutMe.css'

const AboutMe = () => {
    return (
        <>
            <Menubar />
            <Container>
                <Row>
                    <Col className="mt-5 pt-5 aboutMe-details" md={6}>
                        <img className="aboutMeImage" src={"https://i.ibb.co/zrMY71g/IMG-20200211-192039-removebg-2-5.png"} alt="" />
                        <h3 className="mt-5"><span style={{ color: '#64ffda' }}>Hello I'm </span>Moshiuzzaman</h3>
                        <p>I enjoy creating modern web applications. I have Deep knowledge and work with HTML 5, CSS 3, Bootstrap, JSX, JavaScript, ES6, React js. I also have Knowledge and proficiency with react-bootstrap, Material-UI, Redux, and server-side node.js, express.js, MongoDB</p>
                        <div className="headers-icon">
                            <a href='https://www.linkedin.com/in/md-moshiuzzaman-8699641b7/'><FaLinkedinIn className='headers-single-icon' /></a>
                            <a href="https://github.com/moshiuzzaman"><FiGithub className='headers-single-icon' /></a>
                            <a href="https://web.facebook.com/freelancershozon"><FaFacebookF className='headers-single-icon' /></a>

                        </div>
                        <div className='mt-4'>
                            <Button target="_blank"className='buttonstyle' href="https://drive.google.com/file/d/1_g6Ab0KTMDQuT4hTUJ5IfZiaQLmzEEaB/view?usp=sharing">My Resume</Button>
                            <Link to="contactme"><Button className='buttonstyle'>Contact Me</Button></Link>
                        </div>
                    </Col>
                    <Col md={6} className="p-5 aboutMeSkills">
                        <h2>Programming Skills</h2>
                        <h4 className="mt-4">Expertise</h4>
                        <ul className="portfolio-tecgnology">
                            <li> JavaScript</li>
                            <li>ES6</li>
                            <li>React.js</li>
                            <li>REST API</li>
                            <li>React Bootstrap</li>
                            <li>Material-UI</li>
                            <li>Bootstrap4</li>
                            <li>HTML5</li>
                            <li>CSS3</li>
                        </ul>
                        <h4 className="mt-4">Comfortable</h4>
                        <ul className="portfolio-tecgnology">
                            <li>Node.js</li>
                            <li>Express.js</li>
                            <li>MongoDB</li>
                            <li>JSON</li>
                            <li>SASS</li>
                            <li>PHP</li>
                            <li>Wordpress</li>
                        </ul>
                        <h4 className="mt-4">Familiar</h4>
                        <ul className="portfolio-tecgnology">
                            <li>OPP</li>
                            <li>Data structure  </li>
                            <li>Algoridomy</li>
                            <li>Time Complexit</li>
                            <li>Redux.js</li>
                            <li>TypeScript</li>
                            <li>jQuery</li>
                            <li>UI / UX</li>
                        </ul>
                        <h4 className="mt-4">Tools</h4>
                        <ul className="portfolio-tecgnology">
                            <li> Github </li>
                            <li>Firebase</li>
                            <li>Netlify</li>
                            <li>Heroku</li>
                            <li>Webpack</li>
                            <li>Create React App</li>
                            <li>NPM</li>
                            <li>VS Code</li>
                            <li>Chrome Dev tool</li>
                        </ul>

                    </Col>

                </Row>
            </Container>
            <Footer />
        </>
    );
};

export default AboutMe;